import { create } from "zustand";
import axios from "axios";
import { defaultEmailStreams } from "@components/Email/helpers";

const initialState = {
  appConfig: null,
  campaignId: null,
  colors: {
    background: "#000",
    icon: "#FFF",
    card: "#000",
  },
  coords: null,
  coordsNoLocation: false,
  email: "",
  emailStreams: defaultEmailStreams.map((m) => ({
    ...m,
    value: true,
    id: m.variety,
  })),
  entityInfo: null,
  location: null,
  phone: "",
  preferredLocation: null,
  user: null,
  verificationMethod: null,
  zip: "",
  // ride challenge specifics
  activeStep: "registration",
  alerts: [],
  appLoading: false,
  dashboardData: null,
  membershipInfo: null,
  registrationInfo: null,
  vehicleInfo: null,
  verificationCode: null,
  initLoading: true,
  showOtherEfforts: false,
  associateExternalUserDataAttempts: 0,
  searchParamsOnInit: null,
};

const useAppStore = create((set) => ({
  ...initialState,
  reset: () => set(initialState),
  setAppConfig: (appConfig) => set(() => ({ appConfig })),
  setCampaignId: (campaignId) => set(() => ({ campaignId })),
  setColors: (colors) => set(() => ({ colors })),
  setCoords: (coords) => set(() => ({ coords })),
  setCoordsNoLocation: (coordsNoLocation) => set(() => ({ coordsNoLocation })),
  setEmail: (email) => set(() => ({ email })),
  setEmailStreams: (emailStreams) => set(() => ({ emailStreams })),
  setEntityInfo: (entityInfo) => set(() => ({ entityInfo })),
  setLocation: (location) => set(() => ({ location })),
  setPhone: (phone) => set(() => ({ phone })),
  setPreferredLocation: (preferredLocation) =>
    set(() => ({ preferredLocation })),
  setUser: (user) => set(() => ({ user })),
  setZip: (zip) => set(() => ({ zip })),
  setVerificationMethod: (verificationMethod) =>
    set(() => ({ verificationMethod })),
  // ride challenge specifics
  setAppLoading: (appLoading) => set(() => ({ appLoading })),
  setActiveStep: (activeStep) => set(() => ({ activeStep })),
  setDashboardData: (dashboardData) => set(() => ({ dashboardData })),
  setMembershipInfo: (membershipInfo) => set(() => ({ membershipInfo })),
  setRegistrationInfo: (registrationInfo) => set(() => ({ registrationInfo })),
  setVehicleInfo: (vehicleInfo) => set(() => ({ vehicleInfo })),
  setVerificationCode: (verificationCode) => set(() => ({ verificationCode })),
  fetchAlerts: async (reqData) => {
    try {
      const res = await axios.post("/retrieve-alerts/", reqData);
      set(() => ({ alerts: res.data.response }));
    } catch (err) {
      set((state) => ({ alerts: [] }));
    }
  },
  dismissAlerts: async (reqData) => {
    const dismissedIds = reqData.alert_ids;
    try {
      const res = await axios.post("/dismiss-alerts/", reqData);
      set((state) => ({
        alerts: [...state.alerts].filter(
          (alert) => !dismissedIds.includes(alert.id)
        ),
      }));
    } catch (err) {
      set((state) => ({
        alerts: [...state.alerts].filter(
          (alert) => !dismissedIds.includes(alert.id)
        ),
      }));
    }
  },
  setInitLoading: (initLoading) => set(() => ({ initLoading })),
  setShowOtherEfforts: (showOtherEfforts) => set(() => ({ showOtherEfforts })),
  setAssociateExternalUserDataAttempts: (associateExternalUserDataAttempts) =>
    set(() => ({ associateExternalUserDataAttempts })),
  setSearchParamsOnInit: (searchParamsOnInit) =>
    set(() => ({ searchParamsOnInit })),
}));

export default useAppStore;

// import useAppStore from "@store";
// const user = useAppStore((state) => state.user);

// import { shallow } from "zustand/shallow";
// import useAppStore from "./microsite-store";

// const { admin, setAdmin } = useAppStore(
//   (state) => ({
//     admin: state.admin,
//     setAdmin: state.setAdmin,
//   }),
//   shallow
// );
